var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.129 5.871h-5.331V4.805a2.132 2.132 0 0 0-2.133-2.132h-5.331a2.133 2.133 0 0 0-2.133 2.132v1.066H5.87v1.066h1.099l1.067 20.259c0 1.178.955 2.133 2.133 2.133h11.729a2.133 2.133 0 0 0 2.133-2.133L25.08 6.937h1.051V5.871zM12.268 4.804c0-.588.479-1.066 1.066-1.066h5.331c.588 0 1.066.478 1.066 1.066V5.87h-7.464V4.804zM22.966 27.14l-.002.027v.028c0 .587-.478 1.066-1.066 1.066H10.169a1.068 1.068 0 0 1-1.066-1.066v-.028l-.001-.028L8.037 6.936h15.975L22.966 27.14z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.467 9.069h1.066v17.06h-1.066V9.069zM13.358 26.095 12.267 9.068l-1.064.068 1.091 17.027zM20.805 9.103l-1.064-.067-1.076 17.06 1.064.067z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6c7b499f621c4ce87628e727e325c25f.svg";
export { ForwardRef as ReactComponent };